import WhiteBoard from "./Whiteboard";
import Home from "./Home";
import Privacy from "./Privacy";
import { useState , useEffect, useRef} from "react";
import {Routes, Route } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import BlockNote from "./BlockNotes";
import BlockNoteHandler from "./BlockNoteHandler";
import { LinearProgress } from "@mui/material";


export default function Content({
    colorScheme,
    txtColor,
    bgColor,
    colorTheme,
    loadingScreen,
    theme,
    username,
    selectBg,
    selectColor,
    scrollBarColor,
    sendMessage,
    globalNoteContent,
    setGlobalNoteContent,
    globalBoardContent,
    setGlobalBoardContent,
    sessionId,
    clientId,
    editorInit,
    setEditorInit,
    encrypt,
    setContentLoader,
    findNotePath,
    loggedIn,
    updateTab,
    globalEditors,
    addr,
    value,
    globalNotes,
    findNameById,
    globalNoteContentFromOthers,
    allCarets,
    noteSync,
    globalBoardImages,
    setNoteSync,
    socket,
    allFiles,
    globalBoardContentFromOthers,
}) {
   
const [maxWidth, setMaxWidth] = useState(null);
const editorContainer = useRef()
    return(
        <div className='content-main' ref={editorContainer}>
          
            {
              loggedIn &&
              <Routes>
                <Route path="/" index element={
                  <Home 
                    allFiles={allFiles} 
                    updateTab={updateTab} 
                    value={value} 
                    username={username} 
                  />} />
                <Route path="/editor/:noteId"  element={
                  <BlockNoteHandler 
                    username={username} 
                    addr={addr}
                    setContentLoader={setContentLoader} 
                    setNoteSync={setNoteSync} 
                    noteSync={noteSync} 
                    allCarets={allCarets} 
                    maxWidth={maxWidth} 
                    globalEditors={globalEditors} 
                    globalNoteContentFromOthers={globalNoteContentFromOthers} 
                    findNotePath={findNotePath} 
                    findNameById={findNameById}  
                    updateTab={updateTab} 
                    value={value} 
                    encrypt={encrypt} 
                    setEditorInit={setEditorInit}  
                    editorInit={editorInit} 
                    setGlobalNoteContent={setGlobalNoteContent} 
                    globalNoteContent={globalNoteContent} 
                    loadingScreen={loadingScreen} 
                    clientId={clientId}  
                    sessionId={sessionId}  
                    scrollBarColor={scrollBarColor} 
                    selectColor={selectColor}  
                    selectBg={selectBg} 
                    colorTheme={colorTheme} 
                    bgColor={bgColor} 
                    txtColor={txtColor}  
                    colorScheme={colorScheme} 
                    allFiles={allFiles}
                  />}></Route>
                <Route path="/whiteboard/:boardId" index element={
                  <WhiteBoard 
                    globalBoardContentFromOthers={globalBoardContentFromOthers} 
                    globalBoardImages={globalBoardImages}
                    globalBoardContent={globalBoardContent} 
                    setGlobalBoardContent={setGlobalBoardContent} 
                    theme={theme} colorScheme={colorScheme}  
                    updateTab={updateTab} 
                    value={value} 
                    encrypt={encrypt} 
                    clientId={clientId}  
                    sessionId={sessionId}  
                  />}></Route>
                <Route path="*" element={<><h1>Error 404 - Page not found</h1></>}></Route>
                <Route path="loading" element={<LinearProgress />}></Route>
            </Routes>
            }
        </div>
    )
}